import { ApiService } from './api.service';

const SchemasService = {
    getSchemaById: async function(Id) {
        try {
            let response = await ApiService.get(`v1/schemas/${Id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default SchemasService;

export { SchemasService };
